<template>
  <div class="columns is-multiline">
    <div class="column is-half-desktop">
      <window title="Tag input" height="100%">
        <b-field label="Add some tags">
          <b-taginput v-model="tags1" icon="label" placeholder="Add a tag">
          </b-taginput>
        </b-field>
        <p class="content">
          <b>Tags:</b> {{ tags1 }}</p>
      </window>
    </div>
    <div class="column is-half-desktop">
      <window title="Allow new tags" height="100%">
        <div class="">
          <b-switch v-model="allowNew">
            Allow new tags
          </b-switch>
        </div>
        <b-field label="Enter some tags">
          <b-taginput v-model="tags" :data="filteredTags" autocomplete
          :allowNew="allowNew" field="user.first_name" icon="label"
          placeholder="Add a tag" @typing="getFilteredTags">
          </b-taginput>
        </b-field>
        <pre style="max-height: 400px"><b>Tags:</b>{{ tags }}</pre>
      </window>
    </div>
    <div class="column is-half-desktop">
      <window title="Limits" height="100%">
        <b-field label="Limited to 10 characters">
          <b-taginput maxlength="10" :value="['Bulma', 'Vue', 'Buefy']">
          </b-taginput>
        </b-field>

        <b-field label="Limited to 5 tags">
          <b-taginput maxtags="5" :value="['One', 'Two', 'Three', 'Four']">
          </b-taginput>
        </b-field>

        <b-field label="Limited to 10 characters and 5 tags">
          <b-taginput maxlength="10" maxtags="5" :value="['Red', 'Green', 'Blue', 'White']">
          </b-taginput>
        </b-field>
      </window>
    </div>
    <div class="column is-half-desktop">
      <window title="States" height="100%">
        <b-field label="Success" type="is-success">
          <b-taginput :value="['Tag']">
          </b-taginput>
        </b-field>

        <b-field label="Error" type="is-danger">
          <b-taginput :value="['Tag']">
          </b-taginput>
        </b-field>

        <b-field label="Info" type="is-info">
          <b-taginput :value="['Tag']">
          </b-taginput>
        </b-field>

        <b-field label="Warning" type="is-warning">
          <b-taginput :value="['Tag']">
          </b-taginput>
        </b-field>

        <b-field label="Disabled">
          <b-taginput :value="['Tag']" disabled>
          </b-taginput>
        </b-field>

        <b-field label="Loading">
          <b-taginput :value="['Tag']" loading>
          </b-taginput>
        </b-field>
      </window>
    </div>
  </div>
</template>

<script>
const data = require('@/assets/data/data_test.json');

export default {
  data() {
    return {
      tags1: ['Auckland', 'Wellington', 'Napier'],
      filteredTags: data,
      isSelectOnly: false,
      tags: [],
      allowNew: false,
    };
  },
  methods: {
    getFilteredTags(text) {
      this.filteredTags = data.filter(option => (
        option.user.first_name
          .toString()
          .toLowerCase()
          .indexOf(text.toLowerCase()) >= 0
      ));
    },
  },
};
</script>
